import { useNavigate } from "react-router-dom";
import { SessionDTO } from "../dtos/SessionDTO";

export default function Session(props: {
  session: SessionDTO,
  active?: boolean
}) {
  const navigate = useNavigate();
  const className = `w3-button w3-card w3-left-align flex-grow ${props.active ? 'w3-white' : 'w3-light-grey'}`
  return (
    <button
      className={className}
      onClick={() => {
        navigate(props.session.getLink());
      }}
    >
      <div className="w3-bold">
        {props.session.session_name}
      </div>
      <div>
        {props.session.getStartHumanDate()}
      </div>
      <div>bis</div>
      <div>
        {props.session.getEndHumanDate()}
      </div>
    </button>
  )
}